var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pr-3", attrs: { cols: "12", sm: "6" } },
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.items,
              "item-text": "name",
              outlined: "",
              "hide-details": "",
              dense: "",
              "small-chips": "",
              "item-value": "id",
              value: _vm.value[_vm.inputItem],
              required: ""
            },
            on: { input: _vm.onInputItem }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "6" } },
        [
          _c("v-text-field", {
            attrs: {
              label: "Date",
              dense: "",
              "hide-details": "",
              outlined: "",
              value: _vm.value[_vm.inputDate],
              type: "datetime-local",
              min: "2010-06-07T00:00"
            },
            on: {
              input: function($event) {
                return _vm.$emit("input", {
                  ..._vm.value,
                  [_vm.inputDate]: $event
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }